import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { BrowserModule } from '@angular/platform-browser';

import { ButtonModule } from '@shared/components/button/button.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import {
  FormFieldCrudControlsModule
} from '@shared/components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';

import { CustomFieldRadioComponent } from './custom-field-radio.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    ButtonModule,
    DirectivesModule,
    BrowserModule,
    FormFieldCrudControlsModule
  ],
  declarations: [CustomFieldRadioComponent],
  entryComponents: [CustomFieldRadioComponent],
  exports: [
    CustomFieldRadioComponent
  ]
})
export class CustomFieldRadioModule { }
